import React from "react";
import localizationApi from "./Localizations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";

interface Props {
    locale: string;

    onLocaleChange: (locale: string) => void;
}
const FooterCompR6e: React.FC<Props> = (props) => {
    const footerNcsaVariant = (locale: string) => {
        switch (locale) {
            case "en-US":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="ncsaFooter_US">

                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/ratings/ratings_guide.jsp">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/r6s-m-rating_214090.jpg" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/confirm/ubisoft-confirmation.jsp">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/privacy-certified-globe-color-ubiosoft_110500_1.jpg" alt="" />
                        </a>
                    </div>
                );
            case "fr-CA":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="ncsaFooter_FRCA">
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/ratings/ratings_guide.jsp">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/r6s_esrb_m_fre_214090.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/confirm/ubisoft-confirmation.jsp">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/privacy-certified-globe-color-ubiosoft_110500_1.jpg" alt="" />
                        </a>
                    </div>
                );
            case "es-MX":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="ncsaFooter_ESMX">
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/ratings/ratings_guide.jsp">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/r6s_esrb_m_fre_214090.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/confirm/ubisoft-confirmation.jsp">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/privacy-certified-globe-color-ubiosoft_110500_1.jpg" alt="" />
                        </a>
                    </div>
                );
            case "pt-BR":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="ncsaFooter_PTBR">
                        <a target="_blank" rel="noopener noreferrer" href="http://www.esrb.org/ratings/ratings_guide.jsp">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/vh-final_126698.png" alt="" />
                        </a>
                    </div>
                );
            default:
                return null;
        }
    };

    const footerNcsa = (
        <>
            <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                    <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft-white.png" alt="" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                    <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft_logo_store_white.png" alt="" />
                </a>
            </div>

            {footerNcsaVariant(props.locale)}

            <div className="d-flex flex-column small pt-2">
                <p className="copy text-light text-center">&copy; 2015 Ubisoft Entertainment. All Rights Reserved. Tom Clancy's, Rainbow Six, The Soldier Icon, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.</p>
                <div className="legal d-flex flex-row justify-content-center">
                    <a href="https://support.ubi.com" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        CUSTOMER SUPPORT
                    </a>
                    <a href="https://legal.ubi.com/termsofuse" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT TERMS OF USE
                    </a>
                    <a href="https://legal.ubi.com/privacypolicy" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT PRIVACY POLICY
                    </a>
                </div>
            </div>
        </>
    );

    const footerEmeaVariant = (locale: string) => {
        switch (locale) {
            case "de-DE":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="emeaFooter_DE">
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft_logo_store_white.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.usk.de" >
                            <img src="https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1B7mQaWgeSbWaWICw7EbfG/2830932cd1e8d40a48e809a8f307d3d3/usk16.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft-white.png" alt="" />
                        </a>
                    </div>
                );
            case "ja-JP":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="emeaFooter_JP">
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft_logo_store_white.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.cero.gr.jp/publics/index/17/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/Jp-CERO-Z.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft-white.png" alt="" />
                        </a>
                    </div>
                );
            case "ko-KR":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="emeaFooter_KR">
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft_logo_store_white.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.grac.or.kr/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/100px-GRB_18.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft-white.png" alt="" />
                        </a>
                    </div>
                );
            case "zh-TW":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="emeaFooter_TW">
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft_logo_store_white.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.gamerating.org.tw/gsgi_way.php">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/Tw-GSGI-18.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft-white.png" alt="/" />
                        </a>
                    </div>
                );
            case "ru-RU":
                return (
                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-around" id="emeaFooter_RU">
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft_logo_store_white.png" alt="" />
                        </a>
                        <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/18b_197917.png" alt="" />
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft-white.png" alt="" />
                        </a>
                    </div>
                );
            default:
                return (
                    <div className="d-flex flex-wrap flex-row align-items-center justify-content-around">
                        <a target="_blank" rel="noopener noreferrer" href="https://store.ubisoft.com/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft_logo_store_white.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="http://www.pegi.info/">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/pegi-18_103522.png" alt="" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.ubisoft.com">
                            <img src="https://ubistatic-a.akamaihd.net/0115/R6S/images/ubisoft-white.png" alt="" />
                        </a>
                    </div>
                );
        }
    };
    const footerEmea = (
        <>

            {footerEmeaVariant(props.locale)}

            <div className="d-flex flex-column small">
                <p className="copy text-light text-center small">&copy; 2015 Ubisoft Entertainment. All Rights Reserved. Tom Clancy's, Rainbow Six, The Soldier Icon, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries. The "PS" Family logo is a registered trademark and "PS4" is a trademark of Sony Computer Entertainment Inc. Software platform logo (TM and &copy;) EMA 2006.</p>
                <div className="legal d-flex flex-row justify-content-center">
                    <a href="https://legal.ubi.com/LegalInfoUbisoftEMEA" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        LEGAL INFORMATION
                    </a>
                    <a href="https://legal.ubi.com/termsofuse" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT TERMS OF USE
                    </a>
                    <a href="https://legal.ubi.com/privacypolicy" target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small ">
                        UBISOFT PRIVACY POLICY
                    </a>
                </div>
            </div>
        </>
    );

    var instagramUrl = localizationApi.GetInstagramUrlLocale(props.locale);

    const isNcsa = props.locale === "en-US" || props.locale === "fr-CA" || props.locale === "en-CA" || props.locale === "es-MX" || props.locale === "pt-BR";

    return (
        <footer className="bg-dark">
            <div className="container py-4">
                <div className="d-flex flex-row justify-content-between py-4">
                    <select className="p-2" onChange={(e) => props.onLocaleChange(e.target.value)} value={props.locale}>
                        {Object.keys(localizationApi.supportedLocales).map(k =>
                            <option key={k} value={k}>{localizationApi.supportedLocales[k]}</option>
                        )}
                    </select>

                    <ul className="nav">
                        <li className="nav-item">
                            <a href="https://www.facebook.com/Rainbow6" title="Facebook" className="nav-link">
                                <FontAwesomeIcon icon={faFacebookF} color="#fff" />
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href="https://twitter.com/Rainbow6Game" title="Twitter" className="nav-link">
                                <FontAwesomeIcon icon={faTwitter} color="#fff" />
                            </a>
                        </li>
                        {instagramUrl !== "" ? (
                            <li className="nav-item" id="instagramItem">
                                <a href={instagramUrl} title="Instagram" className="nav-link">
                                    <FontAwesomeIcon icon={faInstagram} color="#fff" />
                                </a>
                            </li>
                        ) : null}
                        <li className="nav-item">
                            <a href="https://www.youtube.com/user/ubisoft" title="YouTube" className="nav-link">
                                <FontAwesomeIcon icon={faYoutube} color="#fff" />
                            </a>
                        </li>
                    </ul>
                </div>
                {isNcsa ? footerNcsa : footerEmea}
            </div>
        </footer>
    );
};

export default FooterCompR6e;
